module.exports = __webpack_public_path__ + "img/mandarin-4.8f2ce1b9.png";